import { onramperApi, type OnramperUrlRequest, type PostOnramperGenerateUrlData } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useOnRamperQuery = (
	payload: OnramperUrlRequest,
	options?: Omit<UseQueryOptions<PostOnramperGenerateUrlData>, 'queryFn' | 'queryKey'>
) => {
	return useQuery({
		queryFn: async () => (await onramperApi).postOnramperGenerateUrl(payload),
		queryKey: ['onRamper', payload],
		...options,
		select: data => data.data,
		staleTime: 0
	});
};
